import { createLucideIcon } from "lucide-react";

export const Eye = createLucideIcon(
    "eye",
    [
        [
            "path",
            {
                d: "M10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10C9.10457 10 10 9.10457 10 8Z",
                key: "4wpnsk",
            },
        ],
        [
            "path",
            {
                d: "M14.3633 7.36324C14.566 7.64746 14.6673 7.78956 14.6673 7.99992C14.6673 8.21028 14.566 8.35238 14.3633 8.6366C13.4526 9.91362 11.1268 12.6666 8.00065 12.6666C4.8745 12.6666 2.54872 9.91363 1.63801 8.6366C1.43533 8.35238 1.33398 8.21028 1.33398 7.99992C1.33398 7.78956 1.43533 7.64746 1.63801 7.36324C2.54871 6.08621 4.8745 3.33325 8.00065 3.33325C11.1268 3.33325 13.4526 6.08621 14.3633 7.36324Z",
                key: "172ibh",
            },
        ],
    ],
);
